<template>
  <div class="date-range">
    <span class="dropdown-span-calendar">Date:</span>
    <v-date-picker
      :input-props='{ class: "dropdown dropdown-calendar", readonly: true }'
      :formats="formats"
      type='text'
      mode='range'
      v-model="days"
      @input="$emit('selectDay', $event)"
      show-caps
      expanded
    />
  </div>
</template>

<script>
  import Vue from 'vue';
  import VCalendar from 'v-calendar';
  import 'v-calendar/lib/v-calendar.min.css';

  const formats = {
    title: 'MMMM YYYY',
    weekdays: 'W',
    navMonths: 'MMM',
    input: ['L', 'YYYY-MM-DD', 'YYYY MM DD'],
    dayPopover: 'L',
    data: ['L', 'YYYY-MM-DD', 'YYYY MM DD'],
  };

  Vue.use(VCalendar, {
    firstDayOfWeek: 2, // Monday
    formats: formats,
  });

  export default {
    name: 'DateRangeFilter',
    props: {
      start: {
        default: null
      },
      end: {
        default: null
      }
    },
    data() {
      return {
        days: {
          start: this.start,
          end: this.end,
        },
        formats: formats
      };
    },
    watch: {
      date(newVal) {
        this.day = newVal != null ? new Date(newVal) : null;
      }
    },
  }
</script>
